import { useState } from 'react';
import { motion } from 'framer-motion';

export default function PerformanceSection() {
  const [activeFilter, setActiveFilter] = useState('전체');

  const filters = ['전체', '안전관리계획서', '유해위험방지계획서', '안전보건대장', 'D.F.S', '안전보건관리체계 구축', '기타'];

  const performances = [
    {
      category: '안전관리계획서',
      image:
        'https://public.readdy.ai/ai/img_res/af019527d4227bf93421dc4755a79a65.jpg',
      title: '㈜세방테크 당진공장 신축공사 안전관리계획서 작성용역',
      client: '○○건설(주)',
      amount: '(주)한창건설',
      period: '2025년',
    },
    {
      category: '안전관리계획서',
      image:
        'https://readdy.ai/api/search-image?query=high%20rise%20commercial%20building%20construction%20site%20with%20advanced%20safety%20equipment%20and%20hazard%20prevention%20systems%20in%20professional%20setting&width=600&height=400&seq=perf-002&orientation=landscape',
      title: '문경온천호텔신축공사 안전관리계획서 작성용역',
      client: '○○개발(주)',
      amount: '(주)한창건설',
      period: '2025년',
    },
    {
      category: '안전관리계획서',
      image:
        'https://readdy.ai/api/search-image?query=infrastructure%20construction%20project%20with%20design%20safety%20review%20documentation%20and%20engineering%20analysis%20in%20modern%20office%20environment&width=600&height=400&seq=perf-003&orientation=landscape',
      title: '테라클㈜ 당진공장 신축공사 안전관리계획서 작성용역',
      client: '○○시청',
      amount: '(주)한창건설',
      period: '2025년',
    },
    {
      category: '안전관리계획서',
      image:
        'https://readdy.ai/api/search-image?query=industrial%20steel%20manufacturing%20facility%20construction%20with%20circular%20storage%20tanks%20and%20comprehensive%20safety%20planning%20documentation%20in%20professional%20engineering%20environment&width=600&height=400&seq=perf-007&orientation=landscape',
      title: '현대제철 원형저장고 공사 안전관리계획서 작성용역',
      client: '현대제철(주)',
      amount: '현대제철(주)',
      period: '2025년',
    },
    {
      category: '안전관리계획서',
      image:
        'https://readdy.ai/api/search-image?query=river%20natural%20disaster%20prevention%20project%20with%20flood%20control%20systems%20and%20safety%20management%20planning%20in%20clean%20construction%20site%20environment&width=600&height=400&seq=perf-008&orientation=landscape',
      title: '함평천 자연재해위험개선 정비사업 안전관리계획서 작성',
      client: '함평군청',
      amount: '함평군청',
      period: '2025년',
    },
    {
      category: '안전관리계획서',
      image:
        'https://readdy.ai/api/search-image?query=industrial%20water%20pipeline%20relocation%20construction%20project%20with%20safety%20documentation%20and%20engineering%20planning%20in%20organized%20construction%20environment&width=600&height=400&seq=perf-009&orientation=landscape',
      title: '두룡리 공업용수관로 이설공사 안전관리계획서 작성용역',
      client: '중부화력발전소',
      amount: '중부화력발전소',
      period: '2025년',
    },
    {
      category: '안전관리계획서',
      image:
        'https://readdy.ai/api/search-image?query=modern%20church%20building%20construction%20project%20with%20comprehensive%20safety%20planning%20documentation%20and%20professional%20engineering%20workspace%20with%20clean%20simple%20background&width=600&height=400&seq=perf-010&orientation=landscape',
      title: '청량리그리스도교회 신축공사 소규모안전관리계획서 작성용역',
      client: '(주)그리스도교회',
      amount: '(주)그리스도교회',
      period: '2025년',
    },
    {
      category: '안전보건관리체계 구축',
      image:
        'https://readdy.ai/api/search-image?query=residential%20complex%20construction%20with%20comprehensive%20safety%20planning%20and%20management%20systems%20in%20organized%20construction%20site&width=600&height=400&seq=perf-004&orientation=landscape',
      title: '○○중대재해처벌법 대비 안전보건관리체계 구축 메뉴얼 작성 용역',
      client: '○○종합건설',
      amount: '(주)00건설',
      period: '2023.06 ~ 2024.08',
    },
    {
      category: '유해위험방지계획서',
      image:
        'https://readdy.ai/api/search-image?query=industrial%20facility%20construction%20with%20hazard%20prevention%20measures%20and%20safety%20protocols%20in%20professional%20construction%20environment&width=600&height=400&seq=perf-005&orientation=landscape',
      title: '문경온천호텔신축공사 유해위험방지계획서 작성',
      client: '○○물류(주)',
      amount: '(주)한창건설',
      period: '2025.07',
    },
    {
      category: '유해위험방지계획서',
      image:
        'https://readdy.ai/api/search-image?query=industrial%20steel%20manufacturing%20facility%20with%20hazard%20prevention%20systems%20and%20safety%20protocols%20in%20professional%20engineering%20environment%20with%20clean%20simple%20background&width=600&height=400&seq=perf-011&orientation=landscape',
      title: '현대제철 원형저장고 공사 유해위험방지계획서 작성용역',
      client: '현대제철(주)',
      amount: '현대제철(주)',
      period: '2026년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=modern%20industrial%20factory%20construction%20site%20with%20safety%20health%20documentation%20and%20professional%20engineering%20management%20systems%20in%20clean%20organized%20workspace&width=600&height=400&seq=perf-012&orientation=landscape',
      title: '㈜세방테크 당진공장 신축공사 안전보건대장 적정성 확인',
      client: '(주)세방테크',
      amount: '(주)세방테크',
      period: '2024년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=luxury%20hotel%20building%20construction%20project%20with%20basic%20safety%20health%20ledger%20documentation%20and%20professional%20management%20in%20clean%20modern%20office&width=600&height=400&seq=perf-013&orientation=landscape',
      title: '문경온천호텔신축공사 기본안전보건대장 작성용역',
      client: '(주)한창건설',
      amount: '(주)한창건설',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=hotel%20construction%20design%20phase%20with%20safety%20health%20documentation%20and%20architectural%20blueprints%20in%20professional%20engineering%20workspace&width=600&height=400&seq=perf-014&orientation=landscape',
      title: '문경온천호텔신축공사 설계안전보건대장 작성용역',
      client: '(주)한창건설',
      amount: '(주)한창건설',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=hotel%20construction%20site%20with%20safety%20health%20management%20documentation%20and%20construction%20workers%20in%20organized%20professional%20environment&width=600&height=400&seq=perf-015&orientation=landscape',
      title: '문경온천호텔신축공사 공사안전보건대장 작성용역',
      client: '(주)한창건설',
      amount: '(주)한창건설',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=industrial%20chemical%20factory%20construction%20with%20basic%20safety%20health%20ledger%20and%20professional%20documentation%20in%20clean%20modern%20facility&width=600&height=400&seq=perf-016&orientation=landscape',
      title: '테라클㈜ 당진공장 신축공사 기본안전보건대장 작성용역',
      client: '테라클(주)',
      amount: '테라클(주)',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=industrial%20plant%20design%20phase%20safety%20health%20documentation%20with%20engineering%20blueprints%20and%20professional%20workspace%20in%20clean%20environment&width=600&height=400&seq=perf-017&orientation=landscape',
      title: '테라클㈜ 당진공장 신축공사 설계안전보건대장 작성용역',
      client: '테라클(주)',
      amount: '테라클(주)',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=industrial%20factory%20construction%20site%20with%20safety%20health%20management%20systems%20and%20professional%20construction%20documentation%20in%20organized%20environment&width=600&height=400&seq=perf-018&orientation=landscape',
      title: '테라클㈜ 당진공장 신축공사 공사안전보건대장 작성용역',
      client: '테라클(주)',
      amount: '테라클(주)',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=steel%20manufacturing%20plant%20construction%20with%20basic%20safety%20health%20ledger%20documentation%20and%20industrial%20engineering%20management%20in%20professional%20setting&width=600&height=400&seq=perf-019&orientation=landscape',
      title: '현대제철 원형저장고 공사 기본안전보건대장 작성용역',
      client: '현대제철(주)',
      amount: '현대제철(주)',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=steel%20factory%20design%20phase%20with%20safety%20health%20documentation%20and%20structural%20engineering%20blueprints%20in%20clean%20professional%20workspace&width=600&height=400&seq=perf-020&orientation=landscape',
      title: '현대제철 원형저장고 공사 설계안전보건대장 작성용역',
      client: '현대제철(주)',
      amount: '현대제철(주)',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=steel%20manufacturing%20construction%20site%20with%20safety%20health%20management%20and%20professional%20construction%20documentation%20in%20organized%20industrial%20environment&width=600&height=400&seq=perf-021&orientation=landscape',
      title: '현대제철 원형저장고 공사 공사안전보건대장 작성용역',
      client: '현대제철(주)',
      amount: '현대제철(주)',
      period: '2025년',
    },
    {
      category: '안전보건대장',
      image:
        'https://readdy.ai/api/search-image?query=river%20flood%20prevention%20construction%20project%20with%20safety%20health%20ledger%20documentation%20and%20natural%20disaster%20prevention%20systems%20in%20clean%20environment&width=600&height=400&seq=perf-022&orientation=landscape',
      title: '함평천 자연재해위험개선 정비사업 공사안전보건대장',
      client: '함평군청',
      amount: '함평군청',
      period: '2025년',
    },
    {
      category: 'D.F.S',
      image:
        'https://readdy.ai/api/search-image?query=bridge%20construction%20project%20with%20structural%20safety%20evaluation%20and%20design%20review%20in%20engineering%20workspace&width=600&height=400&seq=perf-006&orientation=landscape',
      title: '○○교량 건설공사',
      client: '○○도청',
      amount: '220억원',
      period: '2023.04 ~ 2024.05',
    },
  ];

  const filteredPerformances =
    activeFilter === '전체'
      ? performances
      : performances.filter((p) => p.category === activeFilter);

  return (
    <section id="performance" className="py-16 sm:py-24 lg:py-32 bg-[#f5f7fa]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[#ff6b35] text-xs font-semibold tracking-[0.2em] mb-2 sm:mb-3">
            PERFORMANCE
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2b4a] mb-2">
            용역 수행실적
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-[#ff6b35] mb-8 sm:mb-12"></div>
        </motion.div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap gap-2 sm:gap-3 mb-8 sm:mb-12">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-medium transition-all whitespace-nowrap ${
                activeFilter === filter
                  ? 'bg-[#ff6b35] text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* Performance Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {filteredPerformances.map((perf, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer group"
            >
              {/* Image */}
              <div className="relative h-40 sm:h-56 overflow-hidden">
                <img
                  src={perf.image}
                  alt={perf.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-3 sm:top-4 left-3 sm:left-4 px-3 sm:px-4 py-1 sm:py-1.5 bg-[#ff6b35] text-white text-[10px] sm:text-xs font-semibold rounded-full">
                  {perf.category}
                </div>
              </div>

              {/* Content */}
              <div className="p-4 sm:p-6">
                <h3 className="text-base sm:text-xl font-bold text-[#1a2b4a] mb-1 sm:mb-2">
                  {perf.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-5">
                  {perf.client}
                </p>

                <div className="border-t border-gray-200 pt-3 sm:pt-4">
                  <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-3 sm:mb-4">
                    <div>
                      <div className="flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-gray-500 mb-0.5 sm:mb-1">
                        <i className="ri-money-dollar-circle-line text-[#ff6b35]"></i>
                        <span>발주처</span>
                      </div>
                      <div className="text-xs sm:text-sm font-semibold text-[#1a2b4a]">
                        {perf.amount}
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-gray-500 mb-0.5 sm:mb-1">
                        <i className="ri-calendar-line text-[#ff6b35]"></i>
                        <span>용역수행</span>
                      </div>
                      <div className="text-xs sm:text-sm font-semibold text-[#1a2b4a]">
                        {perf.period}
                      </div>
                    </div>
                  </div>

                  <a
                    href="#"
                    className="inline-flex items-center gap-2 text-xs sm:text-sm text-[#ff6b35] font-medium hover:gap-3 transition-all whitespace-nowrap"
                  >
                    상세보기
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center items-center gap-1.5 sm:gap-2 mt-8 sm:mt-12">
          <button className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-white text-gray-600 hover:bg-gray-50 transition-colors text-sm">
            <i className="ri-arrow-left-s-line"></i>
          </button>
          <button className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#ff6b35] text-white font-semibold text-sm">
            1
          </button>
          <button className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-white text-gray-600 hover:bg-gray-50 transition-colors text-sm">
            2
          </button>
          <button className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-white text-gray-600 hover:bg-gray-50 transition-colors text-sm">
            3
          </button>
          <button className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-white text-gray-600 hover:bg-gray-50 transition-colors text-sm">
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
